// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("icons/toolbar/add-above.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("icons/toolbar/add-below.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("icons/toolbar/add.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("icons/statusbar/bell.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("icons/toolbar/bug-dot.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("icons/toolbar/bug.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("icons/sidebar/build.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("icons/arrow/caret-down-empty-thin.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("icons/arrow/caret-down-empty.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("icons/arrow/caret-down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("icons/arrow/caret-left.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("icons/arrow/caret-right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("icons/arrow/caret-up-empty-thin.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("icons/arrow/caret-up.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("icons/search/case-sensitive.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("icons/toolbar/check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("icons/toolbar/circle-empty.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("icons/toolbar/circle.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("icons/toolbar/clear.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("icons/toolbar/close.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("icons/lsp/code-check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("icons/toolbar/code.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("icons/toolbar/collapse-all.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("icons/output/collapse.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("icons/filetype/console.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("icons/toolbar/copy.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("icons/licenses/copyright.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("icons/toolbar/cut.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("icons/toolbar/delete.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("icons/toolbar/download.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("icons/toolbar/duplicate.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("icons/toolbar/edit.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("icons/toolbar/ellipses.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("icons/error.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("icons/toolbar/expand-all.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("icons/output/expand.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("icons/sidebar/extension.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("icons/toolbar/fast-forward.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("icons/toolbar/file-upload.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("icons/filetype/file.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("icons/search/filter-dot.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("icons/toolbar/filter-list.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("icons/search/filter.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("icons/filetype/folder-favorite.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("icons/filetype/folder.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("icons/history.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("icons/filetype/home.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("icons/filetype/html5.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("icons/filetype/image.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("icons/info.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("icons/filetype/inspector.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("icons/filetype/json.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("icons/filetype/julia.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("icons/jupyter/jupyter-favicon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("icons/jupyter/jupyter.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("icons/jupyter/jupyterlab-wordmark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("icons/statusbar/kernel.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("icons/filetype/keyboard.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("icons/toolbar/launch.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("icons/filetype/launcher.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("icons/statusbar/line-form.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("icons/toolbar/link.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("icons/statusbar/list.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("icons/lock.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("icons/filetype/markdown.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("icons/filetype/mermaid.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_66___ = new URL("icons/toolbar/move-down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_67___ = new URL("icons/toolbar/move-up.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_68___ = new URL("icons/toolbar/new-folder.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_69___ = new URL("icons/statusbar/not-trusted.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_70___ = new URL("icons/filetype/notebook.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_71___ = new URL("icons/toolbar/numbering.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_72___ = new URL("icons/toolbar/offline-bolt.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_73___ = new URL("icons/sidebar/palette.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_74___ = new URL("icons/toolbar/paste.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_75___ = new URL("icons/filetype/pdf.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_76___ = new URL("icons/filetype/python.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_77___ = new URL("icons/filetype/r-kernel.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_78___ = new URL("icons/filetype/react.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_79___ = new URL("icons/toolbar/redo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_80___ = new URL("icons/toolbar/refresh.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_81___ = new URL("icons/search/regex.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_82___ = new URL("icons/toolbar/run.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_83___ = new URL("icons/sidebar/running.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_84___ = new URL("icons/toolbar/save.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_85___ = new URL("icons/toolbar/search.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_86___ = new URL("icons/filetype/settings.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_87___ = new URL("icons/sidebar/share.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_88___ = new URL("icons/filetype/spreadsheet.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_89___ = new URL("icons/toolbar/stop.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_90___ = new URL("icons/sidebar/tab.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_91___ = new URL("icons/toolbar/table-rows.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_92___ = new URL("icons/toolbar/tag.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_93___ = new URL("icons/statusbar/terminal.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_94___ = new URL("icons/filetype/text-editor.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_95___ = new URL("icons/sidebar/toc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_96___ = new URL("icons/toolbar/tree-view.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_97___ = new URL("icons/statusbar/trusted.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_98___ = new URL("icons/toolbar/undo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_99___ = new URL("icons/sidebar/user.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_100___ = new URL("icons/sidebar/users.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_101___ = new URL("icons/filetype/vega.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_102___ = new URL("icons/search/word.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_103___ = new URL("icons/filetype/yaml.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_66___);
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_67___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_68___);
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_69___);
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_70___);
var ___CSS_LOADER_URL_REPLACEMENT_71___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_71___);
var ___CSS_LOADER_URL_REPLACEMENT_72___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_72___);
var ___CSS_LOADER_URL_REPLACEMENT_73___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_73___);
var ___CSS_LOADER_URL_REPLACEMENT_74___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_74___);
var ___CSS_LOADER_URL_REPLACEMENT_75___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_75___);
var ___CSS_LOADER_URL_REPLACEMENT_76___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_76___);
var ___CSS_LOADER_URL_REPLACEMENT_77___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_77___);
var ___CSS_LOADER_URL_REPLACEMENT_78___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_78___);
var ___CSS_LOADER_URL_REPLACEMENT_79___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_79___);
var ___CSS_LOADER_URL_REPLACEMENT_80___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_80___);
var ___CSS_LOADER_URL_REPLACEMENT_81___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_81___);
var ___CSS_LOADER_URL_REPLACEMENT_82___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_82___);
var ___CSS_LOADER_URL_REPLACEMENT_83___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_83___);
var ___CSS_LOADER_URL_REPLACEMENT_84___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_84___);
var ___CSS_LOADER_URL_REPLACEMENT_85___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_85___);
var ___CSS_LOADER_URL_REPLACEMENT_86___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_86___);
var ___CSS_LOADER_URL_REPLACEMENT_87___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_87___);
var ___CSS_LOADER_URL_REPLACEMENT_88___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_88___);
var ___CSS_LOADER_URL_REPLACEMENT_89___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_89___);
var ___CSS_LOADER_URL_REPLACEMENT_90___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_90___);
var ___CSS_LOADER_URL_REPLACEMENT_91___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_91___);
var ___CSS_LOADER_URL_REPLACEMENT_92___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_92___);
var ___CSS_LOADER_URL_REPLACEMENT_93___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_93___);
var ___CSS_LOADER_URL_REPLACEMENT_94___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_94___);
var ___CSS_LOADER_URL_REPLACEMENT_95___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_95___);
var ___CSS_LOADER_URL_REPLACEMENT_96___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_96___);
var ___CSS_LOADER_URL_REPLACEMENT_97___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_97___);
var ___CSS_LOADER_URL_REPLACEMENT_98___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_98___);
var ___CSS_LOADER_URL_REPLACEMENT_99___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_99___);
var ___CSS_LOADER_URL_REPLACEMENT_100___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_100___);
var ___CSS_LOADER_URL_REPLACEMENT_101___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_101___);
var ___CSS_LOADER_URL_REPLACEMENT_102___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_102___);
var ___CSS_LOADER_URL_REPLACEMENT_103___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_103___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*-----------------------------------------------------------------------------
| Copyright (c) Jupyter Development Team.
| Distributed under the terms of the Modified BSD License.
|----------------------------------------------------------------------------*/

/* This file was auto-generated by ensureUiComponents() in @jupyterlab/buildutils */

/**
 * (DEPRECATED) Support for consuming icons as CSS background images
 */

/* Icons urls */

:root {
  --jp-icon-add-above: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  --jp-icon-add-below: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  --jp-icon-add: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  --jp-icon-bell: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  --jp-icon-bug-dot: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  --jp-icon-bug: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  --jp-icon-build: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  --jp-icon-caret-down-empty-thin: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  --jp-icon-caret-down-empty: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  --jp-icon-caret-down: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  --jp-icon-caret-left: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  --jp-icon-caret-right: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --jp-icon-caret-up-empty-thin: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  --jp-icon-caret-up: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --jp-icon-case-sensitive: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --jp-icon-check: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --jp-icon-circle-empty: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --jp-icon-circle: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  --jp-icon-clear: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  --jp-icon-close: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  --jp-icon-code-check: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  --jp-icon-code: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  --jp-icon-collapse-all: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  --jp-icon-collapse: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  --jp-icon-console: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  --jp-icon-copy: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  --jp-icon-copyright: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  --jp-icon-cut: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  --jp-icon-delete: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  --jp-icon-download: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  --jp-icon-duplicate: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  --jp-icon-edit: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
  --jp-icon-ellipses: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  --jp-icon-error: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
  --jp-icon-expand-all: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  --jp-icon-expand: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  --jp-icon-extension: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  --jp-icon-fast-forward: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
  --jp-icon-file-upload: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  --jp-icon-file: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  --jp-icon-filter-dot: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
  --jp-icon-filter-list: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  --jp-icon-filter: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  --jp-icon-folder-favorite: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  --jp-icon-folder: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  --jp-icon-history: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
  --jp-icon-home: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
  --jp-icon-html5: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
  --jp-icon-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
  --jp-icon-info: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
  --jp-icon-inspector: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
  --jp-icon-json: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
  --jp-icon-julia: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
  --jp-icon-jupyter-favicon: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
  --jp-icon-jupyter: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
  --jp-icon-jupyterlab-wordmark: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
  --jp-icon-kernel: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
  --jp-icon-keyboard: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
  --jp-icon-launch: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
  --jp-icon-launcher: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
  --jp-icon-line-form: url(${___CSS_LOADER_URL_REPLACEMENT_60___});
  --jp-icon-link: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
  --jp-icon-list: url(${___CSS_LOADER_URL_REPLACEMENT_62___});
  --jp-icon-lock: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
  --jp-icon-markdown: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
  --jp-icon-mermaid: url(${___CSS_LOADER_URL_REPLACEMENT_65___});
  --jp-icon-move-down: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
  --jp-icon-move-up: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
  --jp-icon-new-folder: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
  --jp-icon-not-trusted: url(${___CSS_LOADER_URL_REPLACEMENT_69___});
  --jp-icon-notebook: url(${___CSS_LOADER_URL_REPLACEMENT_70___});
  --jp-icon-numbering: url(${___CSS_LOADER_URL_REPLACEMENT_71___});
  --jp-icon-offline-bolt: url(${___CSS_LOADER_URL_REPLACEMENT_72___});
  --jp-icon-palette: url(${___CSS_LOADER_URL_REPLACEMENT_73___});
  --jp-icon-paste: url(${___CSS_LOADER_URL_REPLACEMENT_74___});
  --jp-icon-pdf: url(${___CSS_LOADER_URL_REPLACEMENT_75___});
  --jp-icon-python: url(${___CSS_LOADER_URL_REPLACEMENT_76___});
  --jp-icon-r-kernel: url(${___CSS_LOADER_URL_REPLACEMENT_77___});
  --jp-icon-react: url(${___CSS_LOADER_URL_REPLACEMENT_78___});
  --jp-icon-redo: url(${___CSS_LOADER_URL_REPLACEMENT_79___});
  --jp-icon-refresh: url(${___CSS_LOADER_URL_REPLACEMENT_80___});
  --jp-icon-regex: url(${___CSS_LOADER_URL_REPLACEMENT_81___});
  --jp-icon-run: url(${___CSS_LOADER_URL_REPLACEMENT_82___});
  --jp-icon-running: url(${___CSS_LOADER_URL_REPLACEMENT_83___});
  --jp-icon-save: url(${___CSS_LOADER_URL_REPLACEMENT_84___});
  --jp-icon-search: url(${___CSS_LOADER_URL_REPLACEMENT_85___});
  --jp-icon-settings: url(${___CSS_LOADER_URL_REPLACEMENT_86___});
  --jp-icon-share: url(${___CSS_LOADER_URL_REPLACEMENT_87___});
  --jp-icon-spreadsheet: url(${___CSS_LOADER_URL_REPLACEMENT_88___});
  --jp-icon-stop: url(${___CSS_LOADER_URL_REPLACEMENT_89___});
  --jp-icon-tab: url(${___CSS_LOADER_URL_REPLACEMENT_90___});
  --jp-icon-table-rows: url(${___CSS_LOADER_URL_REPLACEMENT_91___});
  --jp-icon-tag: url(${___CSS_LOADER_URL_REPLACEMENT_92___});
  --jp-icon-terminal: url(${___CSS_LOADER_URL_REPLACEMENT_93___});
  --jp-icon-text-editor: url(${___CSS_LOADER_URL_REPLACEMENT_94___});
  --jp-icon-toc: url(${___CSS_LOADER_URL_REPLACEMENT_95___});
  --jp-icon-tree-view: url(${___CSS_LOADER_URL_REPLACEMENT_96___});
  --jp-icon-trusted: url(${___CSS_LOADER_URL_REPLACEMENT_97___});
  --jp-icon-undo: url(${___CSS_LOADER_URL_REPLACEMENT_98___});
  --jp-icon-user: url(${___CSS_LOADER_URL_REPLACEMENT_99___});
  --jp-icon-users: url(${___CSS_LOADER_URL_REPLACEMENT_100___});
  --jp-icon-vega: url(${___CSS_LOADER_URL_REPLACEMENT_101___});
  --jp-icon-word: url(${___CSS_LOADER_URL_REPLACEMENT_102___});
  --jp-icon-yaml: url(${___CSS_LOADER_URL_REPLACEMENT_103___});
}

/* Icon CSS class declarations */

.jp-AddAboveIcon {
  background-image: var(--jp-icon-add-above);
}

.jp-AddBelowIcon {
  background-image: var(--jp-icon-add-below);
}

.jp-AddIcon {
  background-image: var(--jp-icon-add);
}

.jp-BellIcon {
  background-image: var(--jp-icon-bell);
}

.jp-BugDotIcon {
  background-image: var(--jp-icon-bug-dot);
}

.jp-BugIcon {
  background-image: var(--jp-icon-bug);
}

.jp-BuildIcon {
  background-image: var(--jp-icon-build);
}

.jp-CaretDownEmptyIcon {
  background-image: var(--jp-icon-caret-down-empty);
}

.jp-CaretDownEmptyThinIcon {
  background-image: var(--jp-icon-caret-down-empty-thin);
}

.jp-CaretDownIcon {
  background-image: var(--jp-icon-caret-down);
}

.jp-CaretLeftIcon {
  background-image: var(--jp-icon-caret-left);
}

.jp-CaretRightIcon {
  background-image: var(--jp-icon-caret-right);
}

.jp-CaretUpEmptyThinIcon {
  background-image: var(--jp-icon-caret-up-empty-thin);
}

.jp-CaretUpIcon {
  background-image: var(--jp-icon-caret-up);
}

.jp-CaseSensitiveIcon {
  background-image: var(--jp-icon-case-sensitive);
}

.jp-CheckIcon {
  background-image: var(--jp-icon-check);
}

.jp-CircleEmptyIcon {
  background-image: var(--jp-icon-circle-empty);
}

.jp-CircleIcon {
  background-image: var(--jp-icon-circle);
}

.jp-ClearIcon {
  background-image: var(--jp-icon-clear);
}

.jp-CloseIcon {
  background-image: var(--jp-icon-close);
}

.jp-CodeCheckIcon {
  background-image: var(--jp-icon-code-check);
}

.jp-CodeIcon {
  background-image: var(--jp-icon-code);
}

.jp-CollapseAllIcon {
  background-image: var(--jp-icon-collapse-all);
}

.jp-CollapseIcon {
  background-image: var(--jp-icon-collapse);
}

.jp-ConsoleIcon {
  background-image: var(--jp-icon-console);
}

.jp-CopyIcon {
  background-image: var(--jp-icon-copy);
}

.jp-CopyrightIcon {
  background-image: var(--jp-icon-copyright);
}

.jp-CutIcon {
  background-image: var(--jp-icon-cut);
}

.jp-DeleteIcon {
  background-image: var(--jp-icon-delete);
}

.jp-DownloadIcon {
  background-image: var(--jp-icon-download);
}

.jp-DuplicateIcon {
  background-image: var(--jp-icon-duplicate);
}

.jp-EditIcon {
  background-image: var(--jp-icon-edit);
}

.jp-EllipsesIcon {
  background-image: var(--jp-icon-ellipses);
}

.jp-ErrorIcon {
  background-image: var(--jp-icon-error);
}

.jp-ExpandAllIcon {
  background-image: var(--jp-icon-expand-all);
}

.jp-ExpandIcon {
  background-image: var(--jp-icon-expand);
}

.jp-ExtensionIcon {
  background-image: var(--jp-icon-extension);
}

.jp-FastForwardIcon {
  background-image: var(--jp-icon-fast-forward);
}

.jp-FileIcon {
  background-image: var(--jp-icon-file);
}

.jp-FileUploadIcon {
  background-image: var(--jp-icon-file-upload);
}

.jp-FilterDotIcon {
  background-image: var(--jp-icon-filter-dot);
}

.jp-FilterIcon {
  background-image: var(--jp-icon-filter);
}

.jp-FilterListIcon {
  background-image: var(--jp-icon-filter-list);
}

.jp-FolderFavoriteIcon {
  background-image: var(--jp-icon-folder-favorite);
}

.jp-FolderIcon {
  background-image: var(--jp-icon-folder);
}

.jp-HistoryIcon {
  background-image: var(--jp-icon-history);
}

.jp-HomeIcon {
  background-image: var(--jp-icon-home);
}

.jp-Html5Icon {
  background-image: var(--jp-icon-html5);
}

.jp-ImageIcon {
  background-image: var(--jp-icon-image);
}

.jp-InfoIcon {
  background-image: var(--jp-icon-info);
}

.jp-InspectorIcon {
  background-image: var(--jp-icon-inspector);
}

.jp-JsonIcon {
  background-image: var(--jp-icon-json);
}

.jp-JuliaIcon {
  background-image: var(--jp-icon-julia);
}

.jp-JupyterFaviconIcon {
  background-image: var(--jp-icon-jupyter-favicon);
}

.jp-JupyterIcon {
  background-image: var(--jp-icon-jupyter);
}

.jp-JupyterlabWordmarkIcon {
  background-image: var(--jp-icon-jupyterlab-wordmark);
}

.jp-KernelIcon {
  background-image: var(--jp-icon-kernel);
}

.jp-KeyboardIcon {
  background-image: var(--jp-icon-keyboard);
}

.jp-LaunchIcon {
  background-image: var(--jp-icon-launch);
}

.jp-LauncherIcon {
  background-image: var(--jp-icon-launcher);
}

.jp-LineFormIcon {
  background-image: var(--jp-icon-line-form);
}

.jp-LinkIcon {
  background-image: var(--jp-icon-link);
}

.jp-ListIcon {
  background-image: var(--jp-icon-list);
}

.jp-LockIcon {
  background-image: var(--jp-icon-lock);
}

.jp-MarkdownIcon {
  background-image: var(--jp-icon-markdown);
}

.jp-MermaidIcon {
  background-image: var(--jp-icon-mermaid);
}

.jp-MoveDownIcon {
  background-image: var(--jp-icon-move-down);
}

.jp-MoveUpIcon {
  background-image: var(--jp-icon-move-up);
}

.jp-NewFolderIcon {
  background-image: var(--jp-icon-new-folder);
}

.jp-NotTrustedIcon {
  background-image: var(--jp-icon-not-trusted);
}

.jp-NotebookIcon {
  background-image: var(--jp-icon-notebook);
}

.jp-NumberingIcon {
  background-image: var(--jp-icon-numbering);
}

.jp-OfflineBoltIcon {
  background-image: var(--jp-icon-offline-bolt);
}

.jp-PaletteIcon {
  background-image: var(--jp-icon-palette);
}

.jp-PasteIcon {
  background-image: var(--jp-icon-paste);
}

.jp-PdfIcon {
  background-image: var(--jp-icon-pdf);
}

.jp-PythonIcon {
  background-image: var(--jp-icon-python);
}

.jp-RKernelIcon {
  background-image: var(--jp-icon-r-kernel);
}

.jp-ReactIcon {
  background-image: var(--jp-icon-react);
}

.jp-RedoIcon {
  background-image: var(--jp-icon-redo);
}

.jp-RefreshIcon {
  background-image: var(--jp-icon-refresh);
}

.jp-RegexIcon {
  background-image: var(--jp-icon-regex);
}

.jp-RunIcon {
  background-image: var(--jp-icon-run);
}

.jp-RunningIcon {
  background-image: var(--jp-icon-running);
}

.jp-SaveIcon {
  background-image: var(--jp-icon-save);
}

.jp-SearchIcon {
  background-image: var(--jp-icon-search);
}

.jp-SettingsIcon {
  background-image: var(--jp-icon-settings);
}

.jp-ShareIcon {
  background-image: var(--jp-icon-share);
}

.jp-SpreadsheetIcon {
  background-image: var(--jp-icon-spreadsheet);
}

.jp-StopIcon {
  background-image: var(--jp-icon-stop);
}

.jp-TabIcon {
  background-image: var(--jp-icon-tab);
}

.jp-TableRowsIcon {
  background-image: var(--jp-icon-table-rows);
}

.jp-TagIcon {
  background-image: var(--jp-icon-tag);
}

.jp-TerminalIcon {
  background-image: var(--jp-icon-terminal);
}

.jp-TextEditorIcon {
  background-image: var(--jp-icon-text-editor);
}

.jp-TocIcon {
  background-image: var(--jp-icon-toc);
}

.jp-TreeViewIcon {
  background-image: var(--jp-icon-tree-view);
}

.jp-TrustedIcon {
  background-image: var(--jp-icon-trusted);
}

.jp-UndoIcon {
  background-image: var(--jp-icon-undo);
}

.jp-UserIcon {
  background-image: var(--jp-icon-user);
}

.jp-UsersIcon {
  background-image: var(--jp-icon-users);
}

.jp-VegaIcon {
  background-image: var(--jp-icon-vega);
}

.jp-WordIcon {
  background-image: var(--jp-icon-word);
}

.jp-YamlIcon {
  background-image: var(--jp-icon-yaml);
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@jupyterlab/ui-components/style/deprecated.css"],"names":[],"mappings":"AAAA;;;8EAG8E;;AAE9E,mFAAmF;;AAEnF;;EAEE;;AAEF,eAAe;;AAEf;EACE,4DAAuD;EACvD,4DAAuD;EACvD,sDAA2C;EAC3C,uDAA+C;EAC/C,0DAAmD;EACnD,sDAA2C;EAC3C,wDAA+C;EAC/C,wEAA6E;EAC7E,mEAAmE;EACnE,6DAAuD;EACvD,8DAAuD;EACvD,+DAAyD;EACzD,uEAAyE;EACzE,4DAAmD;EACnD,kEAAgE;EAChE,yDAA+C;EAC/C,gEAA6D;EAC7D,0DAAiD;EACjD,yDAA+C;EAC/C,yDAA+C;EAC/C,8DAAqD;EACrD,wDAA6C;EAC7C,gEAA6D;EAC7D,4DAAoD;EACpD,2DAAoD;EACpD,wDAA6C;EAC7C,6DAAwD;EACxD,uDAA2C;EAC3C,0DAAiD;EACjD,4DAAqD;EACrD,6DAAuD;EACvD,wDAA6C;EAC7C,4DAAqD;EACrD,yDAAuC;EACvC,8DAAyD;EACzD,0DAAgD;EAChD,6DAAuD;EACvD,gEAA6D;EAC7D,+DAA2D;EAC3D,wDAA8C;EAC9C,8DAAwD;EACxD,+DAA2D;EAC3D,0DAAgD;EAChD,mEAAoE;EACpE,0DAAkD;EAClD,2DAA2C;EAC3C,wDAA8C;EAC9C,yDAAgD;EAChD,yDAAgD;EAChD,wDAAqC;EACrC,6DAAwD;EACxD,wDAA8C;EAC9C,yDAAgD;EAChD,mEAAmE;EACnE,2DAAmD;EACnD,uEAA2E;EAC3E,0DAAmD;EACnD,4DAAsD;EACtD,0DAAiD;EACjD,4DAAsD;EACtD,6DAAyD;EACzD,wDAA6C;EAC7C,wDAA+C;EAC/C,wDAAqC;EACrC,4DAAsD;EACtD,2DAAoD;EACpD,6DAAuD;EACvD,2DAAmD;EACnD,8DAAyD;EACzD,+DAA6D;EAC7D,4DAAsD;EACtD,6DAAuD;EACvD,gEAA6D;EAC7D,2DAAmD;EACnD,yDAA+C;EAC/C,uDAA4C;EAC5C,0DAAkD;EAClD,4DAAsD;EACtD,yDAAgD;EAChD,wDAA6C;EAC7C,2DAAmD;EACnD,yDAA8C;EAC9C,uDAA2C;EAC3C,2DAAmD;EACnD,wDAA6C;EAC7C,0DAAiD;EACjD,4DAAsD;EACtD,yDAA+C;EAC/C,+DAA4D;EAC5D,wDAA6C;EAC7C,uDAA2C;EAC3C,8DAAyD;EACzD,uDAA2C;EAC3C,4DAAuD;EACvD,+DAA4D;EAC5D,uDAA2C;EAC3C,6DAAuD;EACvD,2DAAqD;EACrD,wDAA6C;EAC7C,wDAA6C;EAC7C,0DAA+C;EAC/C,yDAA8C;EAC9C,yDAA4C;EAC5C,yDAA8C;AAChD;;AAEA,gCAAgC;;AAEhC;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":["/*-----------------------------------------------------------------------------\n| Copyright (c) Jupyter Development Team.\n| Distributed under the terms of the Modified BSD License.\n|----------------------------------------------------------------------------*/\n\n/* This file was auto-generated by ensureUiComponents() in @jupyterlab/buildutils */\n\n/**\n * (DEPRECATED) Support for consuming icons as CSS background images\n */\n\n/* Icons urls */\n\n:root {\n  --jp-icon-add-above: url('icons/toolbar/add-above.svg');\n  --jp-icon-add-below: url('icons/toolbar/add-below.svg');\n  --jp-icon-add: url('icons/toolbar/add.svg');\n  --jp-icon-bell: url('icons/statusbar/bell.svg');\n  --jp-icon-bug-dot: url('icons/toolbar/bug-dot.svg');\n  --jp-icon-bug: url('icons/toolbar/bug.svg');\n  --jp-icon-build: url('icons/sidebar/build.svg');\n  --jp-icon-caret-down-empty-thin: url('icons/arrow/caret-down-empty-thin.svg');\n  --jp-icon-caret-down-empty: url('icons/arrow/caret-down-empty.svg');\n  --jp-icon-caret-down: url('icons/arrow/caret-down.svg');\n  --jp-icon-caret-left: url('icons/arrow/caret-left.svg');\n  --jp-icon-caret-right: url('icons/arrow/caret-right.svg');\n  --jp-icon-caret-up-empty-thin: url('icons/arrow/caret-up-empty-thin.svg');\n  --jp-icon-caret-up: url('icons/arrow/caret-up.svg');\n  --jp-icon-case-sensitive: url('icons/search/case-sensitive.svg');\n  --jp-icon-check: url('icons/toolbar/check.svg');\n  --jp-icon-circle-empty: url('icons/toolbar/circle-empty.svg');\n  --jp-icon-circle: url('icons/toolbar/circle.svg');\n  --jp-icon-clear: url('icons/toolbar/clear.svg');\n  --jp-icon-close: url('icons/toolbar/close.svg');\n  --jp-icon-code-check: url('icons/lsp/code-check.svg');\n  --jp-icon-code: url('icons/toolbar/code.svg');\n  --jp-icon-collapse-all: url('icons/toolbar/collapse-all.svg');\n  --jp-icon-collapse: url('icons/output/collapse.svg');\n  --jp-icon-console: url('icons/filetype/console.svg');\n  --jp-icon-copy: url('icons/toolbar/copy.svg');\n  --jp-icon-copyright: url('icons/licenses/copyright.svg');\n  --jp-icon-cut: url('icons/toolbar/cut.svg');\n  --jp-icon-delete: url('icons/toolbar/delete.svg');\n  --jp-icon-download: url('icons/toolbar/download.svg');\n  --jp-icon-duplicate: url('icons/toolbar/duplicate.svg');\n  --jp-icon-edit: url('icons/toolbar/edit.svg');\n  --jp-icon-ellipses: url('icons/toolbar/ellipses.svg');\n  --jp-icon-error: url('icons/error.svg');\n  --jp-icon-expand-all: url('icons/toolbar/expand-all.svg');\n  --jp-icon-expand: url('icons/output/expand.svg');\n  --jp-icon-extension: url('icons/sidebar/extension.svg');\n  --jp-icon-fast-forward: url('icons/toolbar/fast-forward.svg');\n  --jp-icon-file-upload: url('icons/toolbar/file-upload.svg');\n  --jp-icon-file: url('icons/filetype/file.svg');\n  --jp-icon-filter-dot: url('icons/search/filter-dot.svg');\n  --jp-icon-filter-list: url('icons/toolbar/filter-list.svg');\n  --jp-icon-filter: url('icons/search/filter.svg');\n  --jp-icon-folder-favorite: url('icons/filetype/folder-favorite.svg');\n  --jp-icon-folder: url('icons/filetype/folder.svg');\n  --jp-icon-history: url('icons/history.svg');\n  --jp-icon-home: url('icons/filetype/home.svg');\n  --jp-icon-html5: url('icons/filetype/html5.svg');\n  --jp-icon-image: url('icons/filetype/image.svg');\n  --jp-icon-info: url('icons/info.svg');\n  --jp-icon-inspector: url('icons/filetype/inspector.svg');\n  --jp-icon-json: url('icons/filetype/json.svg');\n  --jp-icon-julia: url('icons/filetype/julia.svg');\n  --jp-icon-jupyter-favicon: url('icons/jupyter/jupyter-favicon.svg');\n  --jp-icon-jupyter: url('icons/jupyter/jupyter.svg');\n  --jp-icon-jupyterlab-wordmark: url('icons/jupyter/jupyterlab-wordmark.svg');\n  --jp-icon-kernel: url('icons/statusbar/kernel.svg');\n  --jp-icon-keyboard: url('icons/filetype/keyboard.svg');\n  --jp-icon-launch: url('icons/toolbar/launch.svg');\n  --jp-icon-launcher: url('icons/filetype/launcher.svg');\n  --jp-icon-line-form: url('icons/statusbar/line-form.svg');\n  --jp-icon-link: url('icons/toolbar/link.svg');\n  --jp-icon-list: url('icons/statusbar/list.svg');\n  --jp-icon-lock: url('icons/lock.svg');\n  --jp-icon-markdown: url('icons/filetype/markdown.svg');\n  --jp-icon-mermaid: url('icons/filetype/mermaid.svg');\n  --jp-icon-move-down: url('icons/toolbar/move-down.svg');\n  --jp-icon-move-up: url('icons/toolbar/move-up.svg');\n  --jp-icon-new-folder: url('icons/toolbar/new-folder.svg');\n  --jp-icon-not-trusted: url('icons/statusbar/not-trusted.svg');\n  --jp-icon-notebook: url('icons/filetype/notebook.svg');\n  --jp-icon-numbering: url('icons/toolbar/numbering.svg');\n  --jp-icon-offline-bolt: url('icons/toolbar/offline-bolt.svg');\n  --jp-icon-palette: url('icons/sidebar/palette.svg');\n  --jp-icon-paste: url('icons/toolbar/paste.svg');\n  --jp-icon-pdf: url('icons/filetype/pdf.svg');\n  --jp-icon-python: url('icons/filetype/python.svg');\n  --jp-icon-r-kernel: url('icons/filetype/r-kernel.svg');\n  --jp-icon-react: url('icons/filetype/react.svg');\n  --jp-icon-redo: url('icons/toolbar/redo.svg');\n  --jp-icon-refresh: url('icons/toolbar/refresh.svg');\n  --jp-icon-regex: url('icons/search/regex.svg');\n  --jp-icon-run: url('icons/toolbar/run.svg');\n  --jp-icon-running: url('icons/sidebar/running.svg');\n  --jp-icon-save: url('icons/toolbar/save.svg');\n  --jp-icon-search: url('icons/toolbar/search.svg');\n  --jp-icon-settings: url('icons/filetype/settings.svg');\n  --jp-icon-share: url('icons/sidebar/share.svg');\n  --jp-icon-spreadsheet: url('icons/filetype/spreadsheet.svg');\n  --jp-icon-stop: url('icons/toolbar/stop.svg');\n  --jp-icon-tab: url('icons/sidebar/tab.svg');\n  --jp-icon-table-rows: url('icons/toolbar/table-rows.svg');\n  --jp-icon-tag: url('icons/toolbar/tag.svg');\n  --jp-icon-terminal: url('icons/statusbar/terminal.svg');\n  --jp-icon-text-editor: url('icons/filetype/text-editor.svg');\n  --jp-icon-toc: url('icons/sidebar/toc.svg');\n  --jp-icon-tree-view: url('icons/toolbar/tree-view.svg');\n  --jp-icon-trusted: url('icons/statusbar/trusted.svg');\n  --jp-icon-undo: url('icons/toolbar/undo.svg');\n  --jp-icon-user: url('icons/sidebar/user.svg');\n  --jp-icon-users: url('icons/sidebar/users.svg');\n  --jp-icon-vega: url('icons/filetype/vega.svg');\n  --jp-icon-word: url('icons/search/word.svg');\n  --jp-icon-yaml: url('icons/filetype/yaml.svg');\n}\n\n/* Icon CSS class declarations */\n\n.jp-AddAboveIcon {\n  background-image: var(--jp-icon-add-above);\n}\n\n.jp-AddBelowIcon {\n  background-image: var(--jp-icon-add-below);\n}\n\n.jp-AddIcon {\n  background-image: var(--jp-icon-add);\n}\n\n.jp-BellIcon {\n  background-image: var(--jp-icon-bell);\n}\n\n.jp-BugDotIcon {\n  background-image: var(--jp-icon-bug-dot);\n}\n\n.jp-BugIcon {\n  background-image: var(--jp-icon-bug);\n}\n\n.jp-BuildIcon {\n  background-image: var(--jp-icon-build);\n}\n\n.jp-CaretDownEmptyIcon {\n  background-image: var(--jp-icon-caret-down-empty);\n}\n\n.jp-CaretDownEmptyThinIcon {\n  background-image: var(--jp-icon-caret-down-empty-thin);\n}\n\n.jp-CaretDownIcon {\n  background-image: var(--jp-icon-caret-down);\n}\n\n.jp-CaretLeftIcon {\n  background-image: var(--jp-icon-caret-left);\n}\n\n.jp-CaretRightIcon {\n  background-image: var(--jp-icon-caret-right);\n}\n\n.jp-CaretUpEmptyThinIcon {\n  background-image: var(--jp-icon-caret-up-empty-thin);\n}\n\n.jp-CaretUpIcon {\n  background-image: var(--jp-icon-caret-up);\n}\n\n.jp-CaseSensitiveIcon {\n  background-image: var(--jp-icon-case-sensitive);\n}\n\n.jp-CheckIcon {\n  background-image: var(--jp-icon-check);\n}\n\n.jp-CircleEmptyIcon {\n  background-image: var(--jp-icon-circle-empty);\n}\n\n.jp-CircleIcon {\n  background-image: var(--jp-icon-circle);\n}\n\n.jp-ClearIcon {\n  background-image: var(--jp-icon-clear);\n}\n\n.jp-CloseIcon {\n  background-image: var(--jp-icon-close);\n}\n\n.jp-CodeCheckIcon {\n  background-image: var(--jp-icon-code-check);\n}\n\n.jp-CodeIcon {\n  background-image: var(--jp-icon-code);\n}\n\n.jp-CollapseAllIcon {\n  background-image: var(--jp-icon-collapse-all);\n}\n\n.jp-CollapseIcon {\n  background-image: var(--jp-icon-collapse);\n}\n\n.jp-ConsoleIcon {\n  background-image: var(--jp-icon-console);\n}\n\n.jp-CopyIcon {\n  background-image: var(--jp-icon-copy);\n}\n\n.jp-CopyrightIcon {\n  background-image: var(--jp-icon-copyright);\n}\n\n.jp-CutIcon {\n  background-image: var(--jp-icon-cut);\n}\n\n.jp-DeleteIcon {\n  background-image: var(--jp-icon-delete);\n}\n\n.jp-DownloadIcon {\n  background-image: var(--jp-icon-download);\n}\n\n.jp-DuplicateIcon {\n  background-image: var(--jp-icon-duplicate);\n}\n\n.jp-EditIcon {\n  background-image: var(--jp-icon-edit);\n}\n\n.jp-EllipsesIcon {\n  background-image: var(--jp-icon-ellipses);\n}\n\n.jp-ErrorIcon {\n  background-image: var(--jp-icon-error);\n}\n\n.jp-ExpandAllIcon {\n  background-image: var(--jp-icon-expand-all);\n}\n\n.jp-ExpandIcon {\n  background-image: var(--jp-icon-expand);\n}\n\n.jp-ExtensionIcon {\n  background-image: var(--jp-icon-extension);\n}\n\n.jp-FastForwardIcon {\n  background-image: var(--jp-icon-fast-forward);\n}\n\n.jp-FileIcon {\n  background-image: var(--jp-icon-file);\n}\n\n.jp-FileUploadIcon {\n  background-image: var(--jp-icon-file-upload);\n}\n\n.jp-FilterDotIcon {\n  background-image: var(--jp-icon-filter-dot);\n}\n\n.jp-FilterIcon {\n  background-image: var(--jp-icon-filter);\n}\n\n.jp-FilterListIcon {\n  background-image: var(--jp-icon-filter-list);\n}\n\n.jp-FolderFavoriteIcon {\n  background-image: var(--jp-icon-folder-favorite);\n}\n\n.jp-FolderIcon {\n  background-image: var(--jp-icon-folder);\n}\n\n.jp-HistoryIcon {\n  background-image: var(--jp-icon-history);\n}\n\n.jp-HomeIcon {\n  background-image: var(--jp-icon-home);\n}\n\n.jp-Html5Icon {\n  background-image: var(--jp-icon-html5);\n}\n\n.jp-ImageIcon {\n  background-image: var(--jp-icon-image);\n}\n\n.jp-InfoIcon {\n  background-image: var(--jp-icon-info);\n}\n\n.jp-InspectorIcon {\n  background-image: var(--jp-icon-inspector);\n}\n\n.jp-JsonIcon {\n  background-image: var(--jp-icon-json);\n}\n\n.jp-JuliaIcon {\n  background-image: var(--jp-icon-julia);\n}\n\n.jp-JupyterFaviconIcon {\n  background-image: var(--jp-icon-jupyter-favicon);\n}\n\n.jp-JupyterIcon {\n  background-image: var(--jp-icon-jupyter);\n}\n\n.jp-JupyterlabWordmarkIcon {\n  background-image: var(--jp-icon-jupyterlab-wordmark);\n}\n\n.jp-KernelIcon {\n  background-image: var(--jp-icon-kernel);\n}\n\n.jp-KeyboardIcon {\n  background-image: var(--jp-icon-keyboard);\n}\n\n.jp-LaunchIcon {\n  background-image: var(--jp-icon-launch);\n}\n\n.jp-LauncherIcon {\n  background-image: var(--jp-icon-launcher);\n}\n\n.jp-LineFormIcon {\n  background-image: var(--jp-icon-line-form);\n}\n\n.jp-LinkIcon {\n  background-image: var(--jp-icon-link);\n}\n\n.jp-ListIcon {\n  background-image: var(--jp-icon-list);\n}\n\n.jp-LockIcon {\n  background-image: var(--jp-icon-lock);\n}\n\n.jp-MarkdownIcon {\n  background-image: var(--jp-icon-markdown);\n}\n\n.jp-MermaidIcon {\n  background-image: var(--jp-icon-mermaid);\n}\n\n.jp-MoveDownIcon {\n  background-image: var(--jp-icon-move-down);\n}\n\n.jp-MoveUpIcon {\n  background-image: var(--jp-icon-move-up);\n}\n\n.jp-NewFolderIcon {\n  background-image: var(--jp-icon-new-folder);\n}\n\n.jp-NotTrustedIcon {\n  background-image: var(--jp-icon-not-trusted);\n}\n\n.jp-NotebookIcon {\n  background-image: var(--jp-icon-notebook);\n}\n\n.jp-NumberingIcon {\n  background-image: var(--jp-icon-numbering);\n}\n\n.jp-OfflineBoltIcon {\n  background-image: var(--jp-icon-offline-bolt);\n}\n\n.jp-PaletteIcon {\n  background-image: var(--jp-icon-palette);\n}\n\n.jp-PasteIcon {\n  background-image: var(--jp-icon-paste);\n}\n\n.jp-PdfIcon {\n  background-image: var(--jp-icon-pdf);\n}\n\n.jp-PythonIcon {\n  background-image: var(--jp-icon-python);\n}\n\n.jp-RKernelIcon {\n  background-image: var(--jp-icon-r-kernel);\n}\n\n.jp-ReactIcon {\n  background-image: var(--jp-icon-react);\n}\n\n.jp-RedoIcon {\n  background-image: var(--jp-icon-redo);\n}\n\n.jp-RefreshIcon {\n  background-image: var(--jp-icon-refresh);\n}\n\n.jp-RegexIcon {\n  background-image: var(--jp-icon-regex);\n}\n\n.jp-RunIcon {\n  background-image: var(--jp-icon-run);\n}\n\n.jp-RunningIcon {\n  background-image: var(--jp-icon-running);\n}\n\n.jp-SaveIcon {\n  background-image: var(--jp-icon-save);\n}\n\n.jp-SearchIcon {\n  background-image: var(--jp-icon-search);\n}\n\n.jp-SettingsIcon {\n  background-image: var(--jp-icon-settings);\n}\n\n.jp-ShareIcon {\n  background-image: var(--jp-icon-share);\n}\n\n.jp-SpreadsheetIcon {\n  background-image: var(--jp-icon-spreadsheet);\n}\n\n.jp-StopIcon {\n  background-image: var(--jp-icon-stop);\n}\n\n.jp-TabIcon {\n  background-image: var(--jp-icon-tab);\n}\n\n.jp-TableRowsIcon {\n  background-image: var(--jp-icon-table-rows);\n}\n\n.jp-TagIcon {\n  background-image: var(--jp-icon-tag);\n}\n\n.jp-TerminalIcon {\n  background-image: var(--jp-icon-terminal);\n}\n\n.jp-TextEditorIcon {\n  background-image: var(--jp-icon-text-editor);\n}\n\n.jp-TocIcon {\n  background-image: var(--jp-icon-toc);\n}\n\n.jp-TreeViewIcon {\n  background-image: var(--jp-icon-tree-view);\n}\n\n.jp-TrustedIcon {\n  background-image: var(--jp-icon-trusted);\n}\n\n.jp-UndoIcon {\n  background-image: var(--jp-icon-undo);\n}\n\n.jp-UserIcon {\n  background-image: var(--jp-icon-user);\n}\n\n.jp-UsersIcon {\n  background-image: var(--jp-icon-users);\n}\n\n.jp-VegaIcon {\n  background-image: var(--jp-icon-vega);\n}\n\n.jp-WordIcon {\n  background-image: var(--jp-icon-word);\n}\n\n.jp-YamlIcon {\n  background-image: var(--jp-icon-yaml);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
